var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hierarchy-project-node",class:{ 'hierarchy-project-node--active': _vm.isActive },on:{"click":_vm.selectProject}},[_c('div',{staticClass:"project-label"},[_vm._v(_vm._s(_vm.project.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }